import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";
import Collapse from "./Collapse";

const CGRFApplicationDetailsView = ({
  applicationData,
  isExpandable = true,
  t,
}) => {
  const fields = useMemo(
    () => [
      {
        name: "Consumer Number",
        key: "consumerNumber",
        isRequired: true,
      },
      {
        name: "Name of Complainant",
        key: "consumerName",
        isRequired: true,
      },

      {
        name: "Full address of the Complainant",
        key: "consumerAddress",
        isRequired: true,
      },
      {
        name: "Pincode",
        key: "pincode",
        isRequired: true,
      },
      {
        name: "Mobile Number",
        key: "phoneNo",
        isRequired: true,
      },
      {
        name: "Email",
        key: "emailAddress",
        isRequired: true,
      },
      {
        name: "Fax Number",
        key: "faxNo",
        isRequired: true,
      },
      {
        name: "Distribution License",
        key: "distributionLicensee",
        isRequired: true,
      },
    ],
    []
  );

  return (
    <>
      <Collapse title={"Application Details"} isExpandable={isExpandable}>
        <Row className="d-flex  mb-2">
          {fields.map(({ name, key, isRequired, renderField }) => {
            const value = get(applicationData, key, "");
            return (
              <Col key={key} lg={6} className="mb-1">
                <Row>
                  <Col md={5}>{t(name)}:</Col>
                  <Col
                    md={7}
                    className="fw-semibold"
                    style={{ wordBreak: "break-word" }}
                  >
                    {renderField
                      ? renderField(value)
                      : get(applicationData, key, null) ??
                        (isRequired ? "-" : "N/A")}
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Collapse>
    </>
  );
};

CGRFApplicationDetailsView.propTypes = {
  applicationData: PropTypes.object,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(CGRFApplicationDetailsView);
